export default "__VITE_ASSET__738de076__"